'use strict';

angular.module('ClinicApp').controller('ModalClinicAwardGuideCtrl', function($scope, $modalInstance, $q, clinic, award, awardPlacementType, ClinicConfig, OCModalUtil, OCDomUtil, CurrentUser) {
  $scope.clinic = clinic;
  $scope.codeSnippet = award.codeSnippet;
  $scope.user = CurrentUser.getUser();

  // 1 - Send instructions to IT person.
  // 2 - Place award independently.
  $scope.awardPlacementType = awardPlacementType && [1, 2].indexOf(awardPlacementType) !== -1 ? awardPlacementType : 0;

  $scope.itPerson = {
    email: null,
    notifying: false,
    notified: false,
  };

  $scope.guide = {
    step: 1,
  };

  $scope.sendInstructionsToItPerson = function() {
    $scope.awardPlacementType = 1;
  };

  $scope.placeAwardIndependently = function() {
    $scope.awardPlacementType = 2;
  };

  $scope.emailItPerson = function() {
    if (!$scope.itPerson.email) {
      return $q.reject();
    }

    $scope.itPerson.notifying = true;

    // Messages on behalf of yahoo.com could not be delivered due to domain policy restrictions.
    var sendFromClinicOwner = $scope.user && !(/^.+@yahoo\.com$/i).test($scope.user.email);

    return $q.when()
      .then(() => {
        if (sendFromClinicOwner) {
          return OCModalUtil.showModal(
            'clinicAwardItEmail',
            {
              clinic: $scope.clinic,
              sender: {
                name: $scope.user.firstName,
                email: $scope.user.email,
              },
              recepient: {
                email: $scope.itPerson.email,
              },
              codeSnippet: $scope.codeSnippet,
            },
          );
        }
      })
      .then(() => saveItEmail($scope.itPerson.email))
      .then(() => {
        $scope.itPerson.notified = true;
      })
      .finally(() => {
        $scope.itPerson.notifying = false;
      });
  };

  $scope.verifyAward = function() {
    $modalInstance.close();
  };

  $scope.cancel = function() {
    $modalInstance.dismiss('cancel');
  };

  function saveItEmail(itEmail) {
    var action = 'https://docs.google.com/forms/d/1enzs7B5C_BIOSeKLdZOrmd701yzf4FBwoGWMxTTM5Jo/formResponse';
    var data = {
      'entry.353094188': $scope.user ? $scope.user.email : '',
      'entry.961728375': $scope.user ? $scope.user.firstName : '',
      'entry.146073402': $scope.clinic.name,
      'entry.410683125': $scope.clinic.address.locality,
      'entry.1117515201': $scope.clinic.primarySpecialty.namePlural,
      'entry.1289604827': itEmail,
      'entry.456553477': ClinicConfig.HOSTNAME,
    };

    return OCDomUtil.submitThroughIframe(action, 'POST', data);
  }
});
